import { render } from "./BookingCancelled.vue?vue&type=template&id=dca90564&scoped=true"
import script from "./BookingCancelled.vue?vue&type=script&lang=js"
export * from "./BookingCancelled.vue?vue&type=script&lang=js"

import "./BookingCancelled.vue?vue&type=style&index=0&id=dca90564&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca90564"]])

export default __exports__